import api from "../baseurl";

const Park = async () => {
  const colonyList = await api.post(`industrial-parks/index`).json();
  //console.log(colonyList);
  return colonyList.data.industrialParks;
};

export default Park;
